var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StandardLayout',{attrs:{"viewingProjects":true,"viewingProject":_vm.activeProject}},[(!_vm.loading)?_c('div',{staticClass:"main-panel"},[_c('ProjectForm',{attrs:{"project":_vm.activeProject},on:{"updating":_vm.onProjectUpdate,"change":function($event){_vm.projectDirty = true}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }